import React, { useRef, useState, useEffect } from 'react'
import { Button, Card, CardBody, CardTitle, CardHeader, Col, Container, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, Row, ModalHeader } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import SimpleBar from 'simplebar-react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import List from 'list.js';
import Flatpickr from "react-flatpickr";
import { ThreeCircles } from 'react-loader-spinner'

import firebase from "firebase/compat/app";
import "firebase/firestore";
import "firebase/auth";
import 'firebase/storage';
import {serverTimestamp} from 'firebase/firestore';
import { getDownloadURL, uploadBytesResumable, uploadBytes, getStorage, ref } from "firebase/storage";

const SpeciesDetails = () => {
  
  document.title = "Species Details | Fish-Trak - Internal Management Dashboard";
  
  //On mount variables
  const { speciesId } = useParams();
  const navigate = useNavigate();
  const storage = getStorage();
  const speciesRef = firebase.firestore().collection('species').doc(speciesId);
  
  //Session booleans
  const [initialLoad, setInitialLoad] = useState(true);
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const [fetchingCatches, setFetchingCatches] = useState(true);
  const [fetchedData, setFetchedData] = useState(false);
  
  //Data variables
  const [speciesObject, setSpeciesObject] = useState({});
  const [speciesCatches, setSpeciesCatches] = useState([]);
  
  //Update and delete
  const [isUploading, setIsUploading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRestoring, setIsRestoring] = useState(false);
  const [updatedImage, setUpdatedImage] = useState(null);
  
  //Get user details
  const getSpeciesDetails = async () => {
    speciesRef
    .get()
    .then((speciesDoc) => {
      const speciesData = speciesDoc.data();
      speciesData.id = speciesData.id;
      speciesData.date = speciesData && speciesData.created_at && speciesData.created_at.toDate().toLocaleString('en-US', {year: 'numeric', month: 'short', day: 'numeric'});
      setSpeciesObject(speciesData);
      setFetchingDetails(false);
      
      setEditModal(false);
      setIsUploading(false);
      setIsUpdating(false);
      setDeleteModal(false);
      setIsDeleting(false);
      setRestoreModal(false);
      setIsRestoring(false);
    })
    .catch((error) => {
      setFetchingDetails(false);
      alert('Could not get species details. Please try again.');
    });  
  };
  
  //Get species catches
  const getSpeciesCatches = async () => {
    firebase
     .firestore()
     .collection('catches')
     .where('fish_species', '==', speciesRef)
     .orderBy('catch_date', 'desc')
     .onSnapshot(
          querySnapshot => {
              const catchesArray = []
              querySnapshot.forEach(doc => {
                  const catchItem = doc.data();
                  catchItem.id = doc.id;
                  catchItem.angler = catchItem.user_name;
                  catchItem.user_link = '../../user/details/' + catchItem.user.id; 
                  const catchDate = catchItem && catchItem.catch_date && catchItem.catch_date.toDate().toLocaleString('en-US', {year: 'numeric', month: 'short', day: 'numeric'});
                  catchItem.date = catchDate;
                  catchItem.link = '../../catch/details/' + catchItem.id;  
                  catchItem.tag_link = '../../tag/details/' + catchItem.tag.id;  
                  catchesArray.push(catchItem);
              });
              setSpeciesCatches(catchesArray);
              setFetchingCatches(false);
              setFetchedData(true);
          },
          error => {
              console.log(error);
          }
      );
  }
  
  const [editModal, setEditModal] = useState(false);
  function toggleEditModal() {
      setEditModal(!editModal);
  }
  
  const [deleteModal, setDeleteModal] = useState(false);
  function toggleDeleteModal() {
      setDeleteModal(!deleteModal);
  }
  
  const [restoreModal, setRestoreModal] = useState(false);
  function toggleRestoreModal() {
      setRestoreModal(!restoreModal);
  }
  
  const submitUpdateForm = async (event) => {
  
      setIsUploading(true);
      event.preventDefault();
      
      setIsUpdating(true);
      
      if(updatedImage) {
          updateImage(event);
      }
      else {
          updateSpecies(event);
      }
  
  }
  
  const updateImage = async (event) => {
      
      
      event.preventDefault();
    
    const imageFileName = '/fish-species/' + event.target.species_name.value.replace(/[^0-9a-zA-Z-]/g, '-');
         
    const storageRef = ref(storage, imageFileName);
  
    const uploadTask = uploadBytesResumable(storageRef, updatedImage);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("upload is" + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload paused");
            break;
          case "running":
            console.log("Upload running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
        setIsUpdating(false);
          alert('Could not update species image. Please try again.');
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
          updateSpecies(event, downloadedURL);
        });
      }
    );
  };
  
  const updateSpecies = async (event, downloadedURL) => {
              
    //Create array of catch data
      const speciesData = {
        updated_at: serverTimestamp(),
      };
      
      if(event.target.species_name.value != speciesObject.name) {
          speciesData['name'] = event.target.species_name.value.replace(/[^0-9a-zA-Z'-,.?& ]/g, '');
      }
      if(event.target.species_name.value != speciesObject.fish_type) {
          speciesData['fish_type'] = event.target.fish_type.value;
      }
      if(downloadedURL) {
          speciesData['image_url'] = downloadedURL;
      }
              
      //Create new catch in firestore
      speciesRef
          .update(speciesData)
          .then((speciesResponse) => {
            alert('The species has been updated successfully!');
            getSpeciesDetails(); 
          })
          .catch((error) => {
            setIsUpdating(false);
            alert('Could not update species entry. Please try again.');
          });  
  };
  
  const deleteSpecies = async () => {
      
      setIsDeleting(true);
              
      //Delete species from database
      speciesRef
        .update({
          updated_at: serverTimestamp(),
          deleted: true
        })
        .then(() => {
          alert('The species had been deleted successfully!');
          getSpeciesDetails();
        })
        .catch((error) => {
          setIsDeleting(false);
          alert('Could not delete species entry. Please try again.');
        });
  };
  
  const restoreSpecies = async () => {
      
      setIsRestoring(true);
              
      //Restore species in database
      speciesRef
        .update({
            updated_at: serverTimestamp(),
            deleted: false
          })
        .then(() => {
          alert('The species had been restored successfully!');
          getSpeciesDetails();
        })
        .catch((error) => {
          setIsRestoring(false);
          alert('Could not restore species entry. Please try again.');
        });
  };
  
  const createList = () => {
                  
          const catchListOptions = {
              valueNames: ['image_url', 'name', 'angler', 'location_string', 'tag_number', 'date', 'type'],
              pagination: true,
              indexAsync: true,
              searchColumns: ['name', 'angler', 'location_string', 'tag_number'],
              page: 10
          };    
        
        new List('connected-catch-list', catchListOptions);
   };
  
  useEffect(() => {
    if(initialLoad) {
       setInitialLoad(false);
       if(speciesId) { 
          getSpeciesDetails();
          getSpeciesCatches();
        }
     }
     
     if(fetchedData && !fetchingDetails && speciesObject && speciesCatches && (speciesCatches.length > 0)) {
        setFetchedData(false);
        createList();
      }  
  });
  
  return (
    <React.Fragment>
      <div className="page-content">
        
        <Container fluid>
          
          <Row>
            <Col lg="12">
              <Card>
              <CardHeader>
                  <h4 className="card-title mb-0">Species Details</h4>
              </CardHeader>
                <CardBody>
                
                <ThreeCircles
                visible={fetchingDetails}
                height="100"
                width="100"
                color="#4192C3"
                ariaLabel="three-circles-loading"
                wrapperStyle={{style:"margin: 0px auto"}}
                wrapperClass="justify-content-center"
                />
                
                {!fetchingDetails && !isUpdating && !isDeleting &&
                  <div className="d-flex">
                    <div className="me-3">
                      <img
                        src={speciesObject.image_url}
                        alt={speciesObject.name}
                        className="avatar-lg rounded img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{speciesObject.name}</h5>
                        <p className="mb-1">{speciesObject.date}</p>
                        <p className="mb-0"><span className="badge badge-soft-success text-uppercase">{speciesObject.fish_type}</span></p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="edit">
                            <button className="btn btn-md btn-warning edit-item-btn" data-bs-toggle="modal" data-bs-target="#updateModal" onClick={() => toggleEditModal()}><i className="mdi mdi-square-edit-outline"></i></button>
                        </div>
                        
                        {!speciesObject.deleted &&
                        <div className="remove">
                            <button className="btn btn-md btn-danger remove-item-btn" data-bs-toggle="modal" data-bs-target="#deleteModal" onClick={() => toggleDeleteModal()}><i className="mdi mdi-delete-outline"></i></button>
                        </div>
                        }
                        {speciesObject.deleted &&
                        <div className="remove">
                            <button className="btn btn-md btn-success remove-item-btn" data-bs-toggle="modal" data-bs-target="#restoreModal" style={{ backgroundColor: "green" }} onClick={() => toggleRestoreModal()}><i className="mdi mdi-history"></i></button>
                        </div>
                        }
                        
                    </div>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          <Row>
              <Col lg={12}>
                  <Card>
                      <CardHeader>
                          <h4 className="card-title mb-0">Species Catches</h4>
                      </CardHeader>
          
                      <CardBody>
                          <div id="connected-catch-list">
                              <Row className="g-4 mb-3">
                                  <Col className="col-sm">
                                          <div className="search-box ms-2">
                                              <input type="search" className="fuzzy-search form-control" placeholder="Search Catches..." />
                                          </div>
                                  </Col>
                              </Row>
          
                              <div className="table-responsive table-card mt-3 mb-1">
                                  <table className="table align-middle table-nowrap" id="connected-catch-table">
                                      <thead className="table-light">
                                          <tr>
                                              <th scope="col" style={{ width: "50px" }}>View</th>
                                              <th data-sort="image_url">Image</th>
                                              <th className="sort" data-sort="name">Catch Name</th>
                                              <th className="sort" data-sort="angler">Angler Name</th>
                                              <th className="sort" data-sort="location_string">Catch Location</th>
                                              <th className="sort" data-sort="tag_number">Tag Number</th>
                                              <th className="sort" data-sort="weight">Weight</th>
                                              <th className="sort" data-sort="length">Length</th>
                                              <th className="sort" data-sort="date" data-default-order='desc'>Catch Date</th>
                                              <th className="sort" data-sort="type">Type</th>
                                          </tr>
                                      </thead>
                                      <tbody className="list form-check-all">
                                      
                                          {speciesCatches && (speciesCatches.length > 0) && speciesCatches.map((catchItem, index) => ( 
                                          <tr key={index}>
                                              <th scope="row">
                                                  <a className="btn btn-sm btn-success edit-item-btn" href={catchItem.link}><i className="mdi mdi-eye-outline"></i></a>
                                              </th>
                                              <td className="image_url">
                                                  {catchItem.image_url &&<img className="avatar-sm rounded" alt={catchItem.name} src={catchItem.image_url} />}
                                              </td>
                                              <td className="name">{catchItem.name}</td>
                                              <td><a href={catchItem.user_link} className="angler fw-medium link-primary">{catchItem.angler}</a></td>
                                              <td className="location_string">{catchItem.location_string}</td>
                                              <td><a href={catchItem.tag_link} className="tag_number fw-medium link-primary">#{catchItem.tag_number}</a></td>
                                              <td className="weight">
                                                <span className="badge badge-soft-success text-uppercase">
                                                  {catchItem.weight}
                                                  {catchItem && catchItem.metric_system && <span> KG</span>}
                                                  {catchItem && !catchItem.metric_system && <span> LB</span>}
                                                </span>
                                              </td>
                                              <td className="length">
                                                <span className="badge badge-soft-success text-uppercase">
                                                  {catchItem.length}
                                                  {catchItem && catchItem.metric_system && <span> CM</span>}
                                                  {catchItem && !catchItem.metric_system && <span> IN</span>}
                                                </span>
                                              </td>
                                              <td className="date">{catchItem.date}</td>
                                              <td className="type">
                                                  {catchItem && catchItem.recatch &&
                                                      <span className="badge badge-soft-success text-uppercase">Recatch</span>
                                                  }
                                                  {catchItem && !catchItem.recatch &&
                                                      <span className="badge badge-soft-success text-uppercase">Catch</span>
                                                  }
                                              </td>
                                          </tr>
                                          ))}
                                          
                                      </tbody>
                                  </table>
                                  
                                  <ThreeCircles
                                  visible={fetchingCatches}
                                  height="100"
                                  width="100"
                                  color="#4192C3"
                                  ariaLabel="three-circles-loading"
                                  wrapperClass="justify-content-center"
                                  />
                                  
                                  {(!fetchingCatches) && fetchedData && !fetchingDetails && (!speciesCatches || speciesCatches.length == 0) &&
                                  <div className="noresult">
                                      <div className="text-center">
          
                                          <h5 className="mt-2">No Catches Found!</h5>
                                          <p className="text-muted mb-0">We could not find any catches.</p>
                                      </div>
                                  </div>
                                  }
                              </div>
          
                              <div className="d-flex justify-content-end">
                                  <div className="pagination-wrap hstack gap-2">
                                      <ul className="pagination listjs-pagination mb-0"></ul>
                                  </div>
                              </div>
                          </div>
                      </CardBody>
                  </Card>
              </Col>
          </Row>
          
        </Container>
            
      </div>
      
      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={() => { toggleEditModal(); }} className="modal zoomIn" id="editModal" centered >
          <ModalHeader className="bg-light p-3"> Edit Fish Species </ModalHeader>
          
          {!isUpdating &&
          <form className="tablelist-form" onSubmit={submitUpdateForm}>
              <ModalBody>
                  <div className="mb-3">
                      <label htmlFor="name-field" className="form-label">Species Name*</label>
                      <input type="text" id="name-field" className="form-control" placeholder="Atlantic Salmon" name="species_name" defaultValue={speciesObject.name} required />
                  </div>
                  
                  <div className="mb-3">
                      <label htmlFor="image-field" className="form-label">Image File*</label>
                      <tr>
                      <td><img className="avatar-sm rounded" alt={speciesObject.name} src={speciesObject.image_url}/></td>
                      <td><input type="file" name="image_link" id="image-field" className="form-control" onChange={(e) => { setUpdatedImage(e.target.files[0]) }} style={{marginLeft: 20, width: "100%"}}/></td>
                      </tr>
                  </div>
                  
                  <div className="mb-3">
                      <label htmlFor="type-field" className="form-label">Fish Type*</label>
                      <select className="form-control" data-trigger name="fish_type" id="type-field" required defaultValue={speciesObject.fish_type} >
                          <option value="">Select Fish Type</option>
                          <option value="Freshwater">Freshwater</option>
                          <option value="Water">Water</option>
                          <option value="Saltwater">Saltwater</option>
                      </select>
                  </div>   
              </ModalBody>
              <ModalFooter>
                  <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => toggleEditModal()}>Cancel</button>
                      <button type="submit" className="btn btn-success" id="add-btn">Update</button>
                  </div>
              </ModalFooter>
          </form>
          }
          
          <ModalBody>
              <ThreeCircles
                visible={isUpdating}
                height="100"
                width="100"
                color="#4192C3"
                ariaLabel="three-circles-loading"
                wrapperStyle={{style:"margin: 0px auto"}}
                wrapperClass="justify-content-center"
                />
          </ModalBody>
      </Modal>
      
      {/* Remove Modal */}
      <Modal isOpen={deleteModal} toggle={() => { toggleDeleteModal(); }} className="modal zoomIn" id="deleteModal" centered >
      
          {!isDeleting &&
          <ModalBody>
              <div className="mt-2 text-center">
                  <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                      <h4>Delete Fish Species</h4>
                      <p className="text-muted mx-4 mb-0">Are you sure you want to delete this species?</p>
                  </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button type="button" className="btn w-sm btn-light" onClick={() => toggleDeleteModal()}>Cancel</button>
                  <button type="button" className="btn w-sm btn-danger" id="delete-record" onClick={deleteSpecies}>Delete</button>
              </div>
          </ModalBody>
          }
              
              
              <ModalBody>
                  <ThreeCircles
                    visible={isDeleting}
                    height="100"
                    width="100"
                    color="#ff3d60"
                    ariaLabel="three-circles-loading"
                    wrapperStyle={{style:"margin: 0px auto"}}
                    wrapperClass="justify-content-center"
                    />
              </ModalBody>
      </Modal>
      
      {/* Restore Modal */}
      <Modal isOpen={restoreModal} toggle={() => { toggleRestoreModal(); }} className="modal zoomIn" id="restoreModal" centered >
      
          {!isRestoring &&
          <ModalBody>
              <div className="mt-2 text-center">
                  <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                      <h4>Restore Fish Species</h4>
                      <p className="text-muted mx-4 mb-0">Do you really want to restore this species?</p>
                  </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button type="button" className="btn w-sm btn-light" onClick={() => toggleRestoreModal()}>Cancel</button>
                  <button type="button" className="btn w-sm btn-success" id="restore-record" onClick={restoreSpecies}>Restore</button>
              </div>
          </ModalBody>
          }
              
              
              <ModalBody>
                  <ThreeCircles
                    visible={isRestoring}
                    height="100"
                    width="100"
                    color="#4192C3"
                    ariaLabel="three-circles-loading"
                    wrapperStyle={{style:"margin: 0px auto"}}
                    wrapperClass="justify-content-center"
                    />
              </ModalBody>
      </Modal>
      
    </React.Fragment>
  );
};

export default SpeciesDetails;
